/**
 * Where the login screen's branding comes from (U1, design §4.23).
 *
 * Kept apart from the component so the component file exports only components.
 */

import { useQuery } from '@tanstack/react-query';

import { api } from '../../api/client';

export interface Branding {
  name: string | null;
  logo_url: string | null;
}

/**
 * Fetched without a session, so it works before anyone has signed in. A failed
 * request is treated as "no branding": the login form must never wait on, or be
 * broken by, a decoration.
 */
export function useBranding() {
  return useQuery({
    queryKey: ['branding'],
    queryFn: () => api.get<Branding>('/branding', { anonymous: true }),
    staleTime: Infinity,
    retry: false,
  });
}

/** What the top of the page shows, given what the server said and whether the image failed. */
export function brandMode(
  name: string | null,
  logoUrl: string | null,
  imageFailed: boolean,
): 'platform' | 'logo' | 'name' {
  if (!name) return 'platform';
  return logoUrl && !imageFailed ? 'logo' : 'name';
}
